<template>
  <div class="main-charts">
    <!-- Gráfico de Evolución Temporal -->
    <div class="row">
      <div class="col-12">
        <div class="chart-container">
          <h5><i class="fal fa-chart-line text-primary"></i> Evolución Temporal de Solicitudes</h5>
          <div class="chart-wrapper">
            <canvas ref="evolucionChart" width="400" height="200"></canvas>
          </div>
        </div>
      </div>
    </div>

    <!-- Gráficos de Análisis -->
    <div class="row">
      <div class="col-lg-6">
        <div class="chart-container">
          <h5><i class="fal fa-chart-pie text-success"></i> Distribución por Tipo de Solicitud</h5>
          <div class="chart-wrapper">
            <canvas ref="tipoChart" width="300" height="300"></canvas>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="chart-container">
          <h5><i class="fal fa-chart-pie text-info"></i> Distribución por Prioridad</h5>
          <div class="chart-wrapper">
            <canvas ref="prioridadChart" width="300" height="300"></canvas>
          </div>
        </div>
      </div>
    </div>

    <!-- Gráfico de Análisis por Tema - Comentado, ahora es un componente independiente -->
    <!--
    <div class="row">
      <div class="col-12">
        <div class="chart-container">
          <h5><i class="fal fa-chart-bar text-warning"></i> Análisis por Tema</h5>
          <div class="chart-wrapper">
            <canvas ref="temaChart" width="300" height="300"></canvas>
          </div>
        </div>
      </div>
    </div>
    -->

    <!-- Gráfico de Satisfacción por Tipo -->
    <div class="row">
      <div class="col-12">
        <div class="chart-container">
          <h5><i class="fal fa-chart-bar text-success"></i> Satisfacción por Tipo de Solicitud</h5>
          <div class="chart-wrapper">
            <canvas ref="satisfaccionTipoChart" width="400" height="200"></canvas>
          </div>
        </div>
      </div>
    </div>

    <!-- Gráfico de Satisfacción por Tema -->
    <div class="row">
      <div class="col-12">
        <div class="chart-container">
          <h5><i class="fal fa-chart-bar text-info"></i> Satisfacción por Tema de Solicitud</h5>
          <div class="chart-wrapper">
            <canvas ref="satisfaccionTemaChart" width="400" height="300"></canvas>
          </div>
        </div>
      </div>
    </div>

    <!-- Gráfico de Fuentes de Solicitudes -->
    <div class="row">
      <div class="col-12">
        <div class="chart-container">
          <h5><i class="fal fa-chart-pie text-primary"></i> Comparación de Fuentes de Solicitudes</h5>
          <div class="chart-wrapper">
            <canvas ref="fuentesChart" width="400" height="300"></canvas>
          </div>
        </div>
      </div>
    </div>

    <!-- Gráfico de Canales -->
     <!--
    <div class="row">
      <div class="col-12">
        <div class="chart-container">
          <h5><i class="fal fa-chart-area text-info"></i> Performance por Canal</h5>
          <div class="chart-wrapper">
            <canvas ref="canalChart" width="400" height="200"></canvas>
          </div>
        </div>
      </div>
    </div>
    -->

  </div>
</template>

<script>
export default {
  name: 'MainCharts',
  props: {
    evolucionTemporal: {
      type: Array,
      default: () => []
    },
    tipoAnalisis: {
      type: Array,
      default: () => []
    },
    canalAnalisis: {
      type: Array,
      default: () => []
    },
    temaAnalisis: {
      type: Array,
      default: () => []
    },
    prioridadAnalisis: {
      type: Array,
      default: () => []
    },
    satisfaccionPorTipo: {
      type: Array,
      default: () => []
    },
    satisfaccionPorTema: {
      type: Array,
      default: () => []
    },
    fuentesSolicitudes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      charts: {
        evolucion: null,
        tipo: null,
        prioridad: null,
        satisfaccionTipo: null,
        satisfaccionTema: null,
        fuentes: null,
        tema: null,
        canal: null
      }
    }
  },
  watch: {
    evolucionTemporal: {
      handler() {
        this.updateEvolucionChart()
      },
      deep: true
    },
    tipoAnalisis: {
      handler() {
        this.updateTipoChart()
      },
      deep: true
    },
    // temaAnalisis: {
    //   handler() {
    //     this.updateTemaChart()
    //   },
    //   deep: true
    // },
    prioridadAnalisis: {
      handler() {
        this.updatePrioridadChart()
      },
      deep: true
    },
    satisfaccionPorTipo: {
      handler() {
        this.updateSatisfaccionTipoChart()
      },
      deep: true
    },
    satisfaccionPorTema: {
      handler() {
        this.updateSatisfaccionTemaChart()
      },
      deep: true
    },
    fuentesSolicitudes: {
      handler() {
        this.updateFuentesChart()
      },
      deep: true
    },
    canalAnalisis: {
      handler() {
        this.updateCanalChart()
      },
      deep: true
    }
  },
  mounted() {
    this.initializeCharts()
  },
  methods: {
    initializeCharts() {
      this.createEvolucionChart()
      this.createTipoChart()
      this.createPrioridadChart()
      this.createSatisfaccionTipoChart()
      this.createSatisfaccionTemaChart()
      this.createFuentesChart()
      // this.createTemaChart() // Comentado, ahora es un componente independiente
      this.createCanalChart()
    },

    createEvolucionChart() {
      const ctx = this.$refs.evolucionChart
      if (!ctx) return

      this.charts.evolucion = new Chart(ctx, {
        type: 'line',
        data: this.getEvolucionData(),
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true,
              grid: {
                color: 'rgba(0,0,0,0.1)'
              }
            },
            x: {
              grid: {
                color: 'rgba(0,0,0,0.1)'
              }
            }
          },
          plugins: {
            legend: {
              position: 'top'
            }
          }
        }
      })
    },

    createTipoChart() {
      const ctx = this.$refs.tipoChart
      if (!ctx) return

      this.charts.tipo = new Chart(ctx, {
        type: 'doughnut',
        data: this.getTipoData(),
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'bottom'
            }
          }
        }
      })
    },

    createPrioridadChart() {
      const ctx = this.$refs.prioridadChart
      if (!ctx) return

      this.charts.prioridad = new Chart(ctx, {
        type: 'doughnut',
        data: this.getPrioridadData(),
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'bottom'
            }
          }
        }
      })
    },

    createSatisfaccionTipoChart() {
      const ctx = this.$refs.satisfaccionTipoChart
      if (!ctx) return

      this.charts.satisfaccionTipo = new Chart(ctx, {
        type: 'bar',
        data: this.getSatisfaccionTipoData(),
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true,
              max: 5,
              ticks: {
                stepSize: 1
              },
              grid: {
                color: 'rgba(0,0,0,0.1)'
              }
            },
            x: {
              grid: {
                display: false
              }
            }
          },
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  return `Satisfacción: ${context.parsed.y}/5`
                }
              }
            }
          }
        }
      })
    },

    createSatisfaccionTemaChart() {
      const ctx = this.$refs.satisfaccionTemaChart
      if (!ctx) return

      this.charts.satisfaccionTema = new Chart(ctx, {
        type: 'horizontalBar',
        data: this.getSatisfaccionTemaData(),
        options: {
          responsive: true,
          maintainAspectRatio: false,
          indexAxis: 'y',
          scales: {
            x: {
              beginAtZero: true,
              max: 5,
              ticks: {
                stepSize: 1
              },
              grid: {
                color: 'rgba(0,0,0,0.1)'
              }
            },
            y: {
              grid: {
                display: false
              }
            }
          },
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  return `Satisfacción: ${context.parsed.x}/5`
                }
              }
            }
          }
        }
      })
    },

    createFuentesChart() {
      const ctx = this.$refs.fuentesChart
      if (!ctx) return

      this.charts.fuentes = new Chart(ctx, {
        type: 'doughnut',
        data: this.getFuentesData(),
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'right',
              labels: {
                padding: 20,
                usePointStyle: true,
                pointStyle: 'circle'
              }
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  const data = context.dataset.data
                  const total = data.reduce((a, b) => a + b, 0)
                  const percentage = ((context.parsed / total) * 100).toFixed(1)
                  return `${context.label}: ${context.parsed} (${percentage}%)`
                }
              }
            }
          }
        }
      })
    },

    // createTemaChart() {
    //   const ctx = this.$refs.temaChart
    //   if (!ctx) return

    //   this.charts.tema = new Chart(ctx, {
    //     type: 'horizontalBar',
    //     data: this.getTemaData(),
    //     options: {
    //       responsive: true,
    //       maintainAspectRatio: false,
    //       indexAxis: 'y',
    //       scales: {
    //         x: {
    //           beginAtZero: true,
    //           grid: {
    //             color: 'rgba(0,0,0,0.1)'
    //           }
    //         },
    //         y: {
    //           grid: {
    //             display: false
    //           }
    //         }
    //       },
    //       plugins: {
    //         legend: {
    //           display: false
    //         }
    //       }
    //     }
    //   })
    // },

    createCanalChart() {
      const ctx = this.$refs.canalChart
      if (!ctx) return

      this.charts.canal = new Chart(ctx, {
        type: 'radar',
        data: this.getCanalData(),
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            r: {
              beginAtZero: true,
              max: 100,
              grid: {
                color: 'rgba(0,0,0,0.1)'
              }
            }
          },
          plugins: {
            legend: {
              position: 'top'
            }
          }
        }
      })
    },

    getEvolucionData() {
      const labels = this.evolucionTemporal.map(item => item.fecha || item.semana)
      const nuevas = this.evolucionTemporal.map(item => item.nuevas || 0)
      const resueltas = this.evolucionTemporal.map(item => item.resueltas || 0)

      return {
        labels,
        datasets: [
          {
            label: 'Nuevas Solicitudes',
            data: nuevas,
            borderColor: '#1f4e79',
            backgroundColor: 'rgba(31, 78, 121, 0.1)',
            tension: 0.4
          },
          {
            label: 'Solicitudes Resueltas',
            data: resueltas,
            borderColor: '#28a745',
            backgroundColor: 'rgba(40, 167, 69, 0.1)',
            tension: 0.4
          }
        ]
      }
    },

    getTipoData() {
      const labels = this.tipoAnalisis.map(item => item.nombre)
      const data = this.tipoAnalisis.map(item => item.cantidad)
      const colors = [
        '#1f4e79', '#28a745', '#ffc107', '#dc3545',
        '#6f42c1', '#17a2b8', '#fd7e14', '#20c997'
      ]

      return {
        labels,
        datasets: [{
          data,
          backgroundColor: colors.slice(0, data.length),
          borderWidth: 2,
          borderColor: '#fff'
        }]
      }
    },

    getPrioridadData() {
      const labels = this.prioridadAnalisis.map(item => item.prioridad)
      const data = this.prioridadAnalisis.map(item => item.cantidad)
      const colors = [
        '#28a745', // Verde para Baja
        '#ffc107', // Amarillo para Media
        '#dc3545'  // Rojo para Alta
      ]

      return {
        labels,
        datasets: [{
          data,
          backgroundColor: colors.slice(0, data.length),
          borderWidth: 2,
          borderColor: '#fff'
        }]
      }
    },

    getSatisfaccionTipoData() {
      const labels = this.satisfaccionPorTipo.map(item => item.tipo)
      const data = this.satisfaccionPorTipo.map(item => parseFloat(item.satisfaccion))
      const colors = this.satisfaccionPorTipo.map(item => item.color)

      return {
        labels,
        datasets: [{
          label: 'Nivel de Satisfacción',
          data,
          backgroundColor: colors,
          borderColor: colors.map(color => this.adjustBrightness(color, -20)),
          borderWidth: 2,
          borderRadius: 8,
          borderSkipped: false
        }]
      }
    },

    getSatisfaccionTemaData() {
      const labels = this.satisfaccionPorTema.map(item => item.tema)
      const data = this.satisfaccionPorTema.map(item => parseFloat(item.satisfaccion))
      const colors = this.satisfaccionPorTema.map(item => item.color)

      return {
        labels,
        datasets: [{
          label: 'Nivel de Satisfacción',
          data,
          backgroundColor: colors,
          borderColor: colors.map(color => this.adjustBrightness(color, -20)),
          borderWidth: 2,
          borderRadius: 8,
          borderSkipped: false
        }]
      }
    },

    getFuentesData() {
      const labels = this.fuentesSolicitudes.map(item => item.fuente)
      const data = this.fuentesSolicitudes.map(item => item.cantidad)
      const colors = this.fuentesSolicitudes.map(item => item.color)

      return {
        labels,
        datasets: [{
          data,
          backgroundColor: colors,
          borderWidth: 3,
          borderColor: '#fff',
          hoverBorderWidth: 5
        }]
      }
    },

    adjustBrightness(hex, percent) {
      const num = parseInt(hex.replace('#', ''), 16)
      const amt = Math.round(2.55 * percent)
      const R = (num >> 16) + amt
      const G = (num >> 8 & 0x00FF) + amt
      const B = (num & 0x0000FF) + amt
      return '#' + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 +
        (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 +
        (B < 255 ? B < 1 ? 0 : B : 255)).toString(16).slice(1)
    },

    // getTemaData() {
    //   const labels = this.temaAnalisis.map(item => item.nombre)
    //   const data = this.temaAnalisis.map(item => item.cantidad)

    //   return {
    //     labels,
    //     datasets: [{
    //       label: 'Cantidad de Solicitudes',
    //       data,
    //       backgroundColor: 'rgba(31, 78, 121, 0.8)',
    //       borderColor: '#1f4e79',
    //       borderWidth: 1
    //     }]
    //   }
    // },

    getCanalData() {
      const labels = this.canalAnalisis.map(item => item.nombre)
      const satisfaccion = this.canalAnalisis.map(item => (item.satisfaccion || 0) * 20) // Convertir a escala 0-100
      const conversion = this.canalAnalisis.map(item => item.conversion || 0)

      return {
        labels,
        datasets: [
          {
            label: 'Satisfacción',
            data: satisfaccion,
            borderColor: '#28a745',
            backgroundColor: 'rgba(40, 167, 69, 0.2)',
            pointBackgroundColor: '#28a745'
          },
          {
            label: 'Tasa de Conversión',
            data: conversion,
            borderColor: '#1f4e79',
            backgroundColor: 'rgba(31, 78, 121, 0.2)',
            pointBackgroundColor: '#1f4e79'
          }
        ]
      }
    },

    updateEvolucionChart() {
      if (this.charts.evolucion) {
        this.charts.evolucion.data = this.getEvolucionData()
        this.charts.evolucion.update()
      }
    },

    updateTipoChart() {
      if (this.charts.tipo) {
        this.charts.tipo.data = this.getTipoData()
        this.charts.tipo.update()
      }
    },

    updatePrioridadChart() {
      if (this.charts.prioridad) {
        this.charts.prioridad.data = this.getPrioridadData()
        this.charts.prioridad.update()
      }
    },

    updateSatisfaccionTipoChart() {
      if (this.charts.satisfaccionTipo) {
        this.charts.satisfaccionTipo.data = this.getSatisfaccionTipoData()
        this.charts.satisfaccionTipo.update()
      }
    },

    updateSatisfaccionTemaChart() {
      if (this.charts.satisfaccionTema) {
        this.charts.satisfaccionTema.data = this.getSatisfaccionTemaData()
        this.charts.satisfaccionTema.update()
      }
    },

    updateFuentesChart() {
      if (this.charts.fuentes) {
        this.charts.fuentes.data = this.getFuentesData()
        this.charts.fuentes.update()
      }
    },

    // updateTemaChart() {
    //   if (this.charts.tema) {
    //     this.charts.tema.data = this.getTemaData()
    //     this.charts.tema.update()
    //   }
    // },

    updateCanalChart() {
      if (this.charts.canal) {
        this.charts.canal.data = this.getCanalData()
        this.charts.canal.update()
      }
    }
  },
  beforeDestroy() {
    // Destruir gráficos para evitar memory leaks
    Object.values(this.charts).forEach(chart => {
      if (chart) {
        chart.destroy()
      }
    })
  }
}
</script>

<style scoped>
.main-charts {
  margin-bottom: 30px;
}

.chart-container {
  background: white;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.chart-container h5 {
  color: #495057;
  margin-bottom: 20px;
  font-weight: 600;
}

.chart-wrapper {
  position: relative;
  height: 300px;
  margin: 0 auto;
}

.chart-wrapper canvas {
  max-height: 100%;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .chart-wrapper {
    height: 250px;
  }

  .chart-container {
    padding: 15px;
  }
}
</style>
